module.exports = __webpack_public_path__ + "static/media/quotation.498f760c.svg";